export enum DataLayerEvent {
  GtmJs = "gtm.js",
  SignUp = "sign_up",
}

export const GTM_START_FIELD = "gtm.start";

const GTM_ID_RE = /^GTM-[A-Z0-9]+$/;

type DataLayerEntry = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerEntry[];
  }
}

const pushDataLayerEntry = (entry: DataLayerEntry): void => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(entry);
};

export const pushDataLayerEvent = (event: DataLayerEvent): void =>
  pushDataLayerEntry({ event });

export const loadGoogleTagManager = (containerId: string | undefined): void => {
  if (!containerId || !GTM_ID_RE.test(containerId)) {
    return;
  }

  const src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  pushDataLayerEntry({
    [GTM_START_FIELD]: Date.now(),
    event: DataLayerEvent.GtmJs,
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};
